import React, { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { UserAuth } from '../context/AuthContext';

// const Signup = () => {
//   return (
//     <div>
//         <Link to="/signup" className='sign'>Sign up </Link>
//     </div>
//   )
// }


const Signup = () => {
    const [email, setEmail] = useState('');
    const [password, setPassword] = useState('');
    const [ setError] = useState('');
    const { createUser } = UserAuth();
    const navigate = useNavigate();

    //const {createUser} = useState('');
  
    const handleSubmit = async (e) => {
      e.preventDefault();
    //   setError('');
      try {
        await createUser(email, password);
        navigate('/signin')
      } catch (e) {
        setError(e.message);
        console.log(e.message);
      }
    };
  
    return (
      <div className='max-w-[700px] mx-auto my-16 p-4'>
        <div>
          <h1 className='text-2xl font-bold py-2'>Sign up for a free account</h1>
          <p className='py-2'>
            Already have an account yet?{' '}
            <Link to='/signup' className='underline'>
            Sign in.
          </Link>
          <Link to='/' className='underline'>
            Go to page.
          </Link>
          </p>
        </div>
        <form onSubmit={handleSubmit}>
          <div className='flex flex-col py-2'>
            <label className='py-2 font-medium'>Email Address</label>
            <input
              onChange={(e) => setEmail(e.target.value)}
              className='border p-3'
              type='email'
            />
          </div>
          <div className='flex flex-col py-2'>
            <label className='py-2 font-medium'>Password</label>
            <input
              onChange={(e) => setPassword(e.target.value)}
              className='border p-3'
              type='password'
            />
          </div>
          <button className='border border-orange-500 bg-orange-500 hover:bg-orange-500 w-full p-4 my-2 text-white'>
            Sign Up
          </button>
        </form>
      </div>
    );
  };
  


export default Signup